
const ResultsList = ({ results }: { results: string[] }) => {
  return (
    <ul className="text-white/80 text-sm">
      {results.map((result, i) => (
        <li key={i} className="flex items-start mb-2">
          <span className="bg-primary/20 text-primary inline-block w-4 h-4 rounded-full text-xs flex items-center justify-center mr-2 mt-0.5">✓</span>
          {result}
        </li>
      ))}
    </ul>
  );
};

export default ResultsList;
